module.exports = __webpack_public_path__ + "img/de.6c3ae4c0.svg";